"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const useInputDebounce_1 = __importDefault(require("../hooks/useInputDebounce"));
function Input(type = 'text') {
    function InputType({ value, onChange, onBlur, id, isReadOnly }) {
        const [val, debounceOnChange, flush] = (0, useInputDebounce_1.default)({
            value,
            onChange,
        });
        const opts = {};
        if (isReadOnly)
            opts.disabled = 'disabled';
        return (react_1.default.createElement("input", { ...opts, type: type, value: val, id: id, onChange: debounceOnChange, onBlur: () => {
                onBlur();
                flush();
            } }));
    }
    InputType.displayName = `Input(${type.toUpperCase()})`;
    return InputType;
}
exports.default = Input;
//# sourceMappingURL=Input.js.map